<template>
  <div>
    <label v-if="titulo != null">
      {{titulo}}
      <span v-if="tip != null" class="icon is-size-6 cursor-pointer" :title="tip">
        <i class="fa fa-question-circle"></i>
      </span>
    </label>
    <label
      v-for="opcao in listaDeOpcoes"
      :key="opcao"
      :class="{ 'cursor-pointer': !opcao.disabled, 'is-disabled': opcao.disabled}"
      class="radio"
    >
      <input
        v-model="valorSelecionado"
        type="radio"
        :id="opcao?.id"
        :checked="valorSelecionado == opcao.valor"
        :title="opcao.title || opcao.label"
        :name="name"
        :value="opcao.valor"
        :class="{ 'cursor-not-allowed': opcao.disabled }"
        @change="$emit('update:valorSelecionado', valorSelecionado)"
        @click="(event) => _setValorSelecionado(event, opcao)"
      />
      {{opcao.label}}
      <span v-if="!!opcao.tip" class="icon is-size-6 cursor-pointer" :title="opcao.tip">
        <i class="fa fa-question-circle"></i>
      </span>
    </label>
  </div>
</template>

<script>

export default {
  name: "TrfRadioFields",
  props: {
    titulo: {
      type: [String],
      required: false,
      default: null
    },
    tip: {
      type: [String],
      required: false,
      default: null
    },
    listaDeOpcoes: {
      type: [Array],
      required: true,
    },
    required: {
      type: [Boolean],
      required: false,
      default: false
    },
    name: {
      type: [String],
      required:true
    },
    validate: {
      type: [Function],
      required: false,
      default: function validacaoBasica() {
        if(!!this && !this.required) {
          return true;
        }

        if(!!this && this.valorSelecionado != undefined) {
          return false;
        }
      }()
    },
    isValid: {
      type: [Boolean],
      required: false,
      default: !!this && this.validate()
    },
  },
  data() {
    return {
      valorSelecionado: null
    };
  },
  methods: {
    _setValorSelecionado(event, opcao) {
      if(!opcao.disabled) return;
      event.preventDefault();
    },
    validacaoBasica() {
      if(!this.required) {
        return true;
      };

      if(this.valorSelecionado != null) {
        return false;
      }
    },
    _selecionarDefault() {
      const opcoesValidas = this.listaDeOpcoes.find(opcao => {
        return opcao.default;
      });
      if(!!opcoesValidas) {
        this.valorSelecionado = opcoesValidas.valor;
      } else {
        this.valorSelecionado = null;
      }
    },
    _selecionarPorValor(valor, defaultSeInvalido) {
      const opcoesValidas = this.listaDeOpcoes.find(opcao => {
        return opcao.valor == valor;
      });
      if(!!opcoesValidas) {
        this.valorSelecionado = opcoesValidas.valor;
      } else if (defaultSeInvalido) {
        this._selecionarDefault();
      }
    }
  },
  mounted() {
    this._selecionarDefault();
  }, 
};
</script>

<style lang="scss" scoped>
$light-grey: #cccccc;
$dark-grey: #333333;
$orange: #f90;
$dark-orange: #f63;
$is-3: 0.75rem;
$is-6: 3rem;
$is-5: 1.5rem;

label.radio:not(:last-child) {
  margin-right:$is-5;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.is-disabled {
  color: #666666;
  cursor: not-allowed;
}
</style>
